/* tslint:disable */
/* eslint-disable */

/**
 * 0 = SuperAdmin
 * 
 * 1 = Admin
 * 
 * 2 = Supervisor
 * 
 * 3 = Basic
 * 
 * -1 = ElevatedAdmin
 */
export enum Roles {
  SuperAdmin = 0,
  Admin = 1,
  Supervisor = 2,
  Basic = 3,
  ElevatedAdmin = -1
}
